import React from 'react';
import './ContactSection.css';
import {
  FaFacebook,
  FaInstagram,
  FaLinkedin,
  FaPhone,
  FaEnvelope,
  FaMapMarkerAlt,
} from 'react-icons/fa';
import whatsAppIcon from '../assets/tech-whatsapp.png';

function ContactSection() {
  const handleWhatsAppPress = () => {
    const emoji = String.fromCodePoint(0x1F44B); // "👋"
    const rawMessage = `Olá! ${emoji} Quero solicitar um orçamento!`;
    const encodedMessage = encodeURIComponent(rawMessage);
    window.open(`https://wa.me/5511965442886?text=${encodedMessage}`, '_blank');
  };

  return (
    <div className="contact-container">
      <h2>Entre em Contato</h2>
      <p>Estamos prontos para atender você!</p>
      <div className="contact-content">
        {/* Informações de Contato */}
        <div className="contact-info">
          <div className="info-item">
            <FaPhone className="icon" />
            <a href="tel:+5511965442886">+55 (11) 96544-2886</a>
          </div>
          <div className="info-item">
            <FaEnvelope className="icon" />
            <a href="mailto:leal.executivo@gmail.com">leal.executivo@gmail.com</a>
          </div>
          <div className="info-item">
            <FaMapMarkerAlt className="icon" />
            <span>Rua Engenheiro Guilherme Cristiano Frender, 830 - São Paulo, SP</span>
          </div>
        </div>
        {/* Mídias Sociais */}
        <div className="social-media">
          <a href="https://www.facebook.com/people/Leal-Transporte-Executivo/100076164202598/" target="_blank" rel="noopener noreferrer">
            <FaFacebook className="icon facebook" />
          </a>
          <a href="https://www.instagram.com/lealtransporteexecutivo/" target="_blank" rel="noopener noreferrer">
            <FaInstagram className="icon instagram" />
          </a>
          <a href="https://www.linkedin.com/company/leal-transporte-executivo/about/" target="_blank" rel="noopener noreferrer">
            <FaLinkedin className="icon linkedin" />
          </a>
          <a href="#" onClick={handleWhatsAppPress} className="whatsapp-link">
            <img src={whatsAppIcon} alt="WhatsApp" className="icon whatsapp-icon" />
          </a>
        </div>
      </div>
    </div>
  );
}

export default ContactSection;
